import { render, staticRenderFns } from "./TranslationsV1.vue?vue&type=template&id=4b7997a4&"
import script from "./TranslationsV1.vue?vue&type=script&lang=js&"
export * from "./TranslationsV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports